import gql from 'graphql-tag'
import { MutationFunction } from 'react-apollo'

import { LeadContact, LeadContactVariables } from './__generated__/LeadContact'

export const LEAD_CONTACT_MUTATION = gql`
  mutation LeadContact(
    $schoolId: Int
    $externalSchoolId: Int
    $note: String!
    $password: String
    $childParams: LeadContactChildParams
  ) {
    leadContact(
      schoolId: $schoolId
      externalSchoolId: $externalSchoolId
      note: $note
      password: $password
      childParams: $childParams
    ) {
      id
    }
  }
`

export type LeadContactMutationFn = MutationFunction<LeadContact, LeadContactVariables>
